import React from 'react'
import { LinkExternoForm } from './LinkExternoForm'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import storage from '../../../services/stoage.service'
import { logarAcesso } from '../../../services/api-log-acesso'
import _ from 'lodash'

const mapStateToProps = (state) => {
  const currentUser = state.appState.currentUser
  const oidCurrentUser = storage.getOidUser()
  const currentCompany = storage.getCompany()
  const unidadesUsuario = storage.getUnidadesUsuario()
  const units =
    unidadesUsuario === null || unidadesUsuario === undefined || unidadesUsuario.length === 0
      ? currentCompany.unidades || []
      : unidadesUsuario
  const unit = storage.getUnit()
  // unidade selecionada; sem seleção, todas as unidades de acesso do usuário
  const oidsUnits = unit !== null && unit !== undefined ? unit.oid : _.map(units, 'oid').join(',')

  return {
    currentUser,
    oidCurrentUser,
    currentCompany,
    oidsUnits,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

class LinkExternoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageId: undefined,
    }
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    const pageId = _.get(this, 'props.match.params[0]', null)
    if (!_.isEmpty(pageId) && pageId !== this.state.pageId) {
      this.setState((previousState) => ({
        pageId: previousState.pageId !== pageId ? pageId : previousState.pageId,
      }))
      logarAcesso().then()
    }
  }

  render() {
    const content = (
      <LinkExternoForm
        {...this.props}
        oidCurrentUser={this.props.oidCurrentUser}
        currentUser={this.props.currentUser}
        currentCompany={this.props.currentCompany}
        oidsUnits={this.props.oidsUnits}
      />
    )
    return <Page content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkExternoFormPageContainer)
